import { breakpoints } from '@r1-frontend/entities/Layout/Header/types';

import { Profile } from '@r1-frontend/ui-kit/atoms/svg/users';
import { Text } from '@r1-frontend/ui-kit/atoms/typography/text';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { MenuButton } from './MenuButton';

export const UserButton = () => {
    const isSmallMobile = useMatchMediaByWidth(breakpoints.mMobile);

    return (
        <MenuButton>
            <Profile size={isSmallMobile ? 24 : 20}/>
            {!isSmallMobile && (
                <Text $color={'head'} $size={'md'} $weight={'medium'}>Профиль</Text>
            )}
        </MenuButton>
    );
};
